import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeftLink from '../leftlink/leftlink.jsx';
import ManagePin from '../myprofile/managepin.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';


class NavChangePin extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12 m-0 p-0">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{}} >
                    <div className="row">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div> */}
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable
                            pauseOnHover
                              style={{ zIndex: 999999 }}
                        />
                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>
                            <div className="row" style={{ padding: "12px 10px", minHeight: "476px" }}>
                                {/* <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                    <h4 className='logmainheading mainheading'>
                                        Manage PIN
                                    </h4>
                                </div> */}
                                <ManagePin />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavChangePin;


// WEBPACK FOOTER //
// ./src/components/navchangepin/navchangepin.jsx